module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Erforderlich","track":"Required"}}